import StudentReport from '../views/StudentReport';
import ClassReport from '../views/ClassReport';
import Classes from '../views/Classes';

const router = [
  {
    name: 'classes.classes',
    path: '/reports/classes',
    component: Classes,
    meta: {
      requiresAuth: true,
      requiresTeacherRole: true,
    },
  },
  {
    path: '/reports/classes/:class_id',
    component: ClassReport,
    meta: {
      requiresAuth: true,
      requiresTeacherRole: true,
    },
  },
  {
    path: '/reports/classes/:class_id/students/:student_id',
    component: StudentReport,
    meta: {
      requiresAuth: true,
      requiresTeacherRole: true,
    },
  },
];

export default router;



// WEBPACK FOOTER //
// ./src/app/classes/router/index.js